export const isApiSuccess = (response) => response && response.status >= 200 && response.status < 300;
